var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brands" }, [
    _c(
      "ul",
      { staticClass: "brands-list" },
      _vm._l(_vm.brands, function(brand, index) {
        return _c(
          "li",
          {
            key: brand.product_brand_id,
            attrs: {
              id: _vm.itemId(brand, index > 0 ? _vm.brands[index - 1] : {})
            }
          },
          [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.handleOnClick(brand)
                  }
                }
              },
              [_vm._v(_vm._s(brand.product_brand_title))]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "letters-list" },
      _vm._l(_vm.letters, function(letter) {
        return _c("li", { key: letter }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.scrollTo(letter)
                }
              }
            },
            [_vm._v(_vm._s(letter))]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-036707b0", { render: render, staticRenderFns: staticRenderFns })
  }
}